import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
	CustomFormControl,
	CustomFormGroup,
	TagField,
	TagListField,
	TextField
} from '@eventlyte/forms';
import {
	ApiErrorList,
	FormErrorsModal,
	RegistrationStepperControls,
	RegistrationStepperProgress,
	ServerErrorsModal
} from '@eventlyte/registration';
import { TranslocoDirective } from '@jsverse/transloco';
import { AppRoutePaths } from '../../app.routes';
import { LocalRegistrationPageBase } from '../../shared/local-registration-page-base';

@Component({
	selector: 'app-registration-matching-page',
	imports: [
		RegistrationStepperControls,
		RegistrationStepperProgress,
		ServerErrorsModal,
		FormErrorsModal,
		TranslocoDirective,
		TagField,
		TagListField,
		TextField
	],
	templateUrl: './registration-matching-page.html'
})
export class RegistrationMatchingPage extends LocalRegistrationPageBase {
	protected override currentStepNumber = 2;

	protected override exclusiveTagValueByKey: Readonly<Record<string, string>> = {
		bgovBmBusinessObjectives: 'No specific focus',
		bgovBmTechnologiesInterested: 'Not Applicable (N/A)'
	};

	protected formGroup = new FormGroup({
		bgovBmHopingToAchieve: new CustomFormControl('fields.bgovBmHopingToAchieve.label', [
			this.validators.required()
		]),
		bgovBmCurrentStageOfProduct: new CustomFormControl(
			'fields.bgovBmCurrentStageOfProduct.label',
			[this.validators.required()]
		),
		bgovBmOrganisationsCurrentAiAdoptionStage: new CustomFormControl(
			'fields.bgovBmOrganisationsCurrentAiAdoptionStage.label',
			[this.validators.required()]
		),
		bgovBmTechnologiesInterested: new CustomFormControl(
			'fields.bgovBmTechnologiesInterested.label',
			[this.validators.required()]
		),
		bgovBmBudgetAllocation: new CustomFormControl('fields.bgovBmBudgetAllocation.label', [
			this.validators.required()
		]),
		bgovBmCurrentBusinessChallenges: new CustomFormControl(
			'fields.bgovBmCurrentBusinessChallenges.label',
			[this.validators.required()]
		),
		bgovBmBusinessObjectives: new CustomFormControl('fields.bgovBmBusinessObjectives.label', [
			this.validators.required()
		])
	});

	public override ngOnInit(): void {
		super.ngOnInit();

		this.formGroups.push(this.formGroup);
		this.validationFormGroups = [new CustomFormGroup({ formGroup: this.formGroups[0] })];
	}

	public override ngOnDestroy(): void {
		super.ngOnDestroy();
	}

	protected continue(): void {
		super.goToNextStep(this.formGroups, () => {
			this.saving.set(true);

			this.registrationService
				.register(this.recordStateService.getRecord(), false, this.currentStepNumber)
				.subscribe({
					next: () => {
						this.router.navigate([AppRoutePaths.RegistrationGroup]);
					},
					error: (apiErrorList: ApiErrorList) => {
						this.serverErrorList.set(apiErrorList);
						this.showServerErrors.set(true);
						this.saving.set(false);
					}
				});
		});
	}
}
